/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DashboardRange,
  DashboardRange$inboundSchema,
  DashboardRange$Outbound,
  DashboardRange$outboundSchema,
} from "./dashboardrange.js";

/**
 * What a dashboard opens on: its date range and the values picked for each catalog dimension its filter bar offers. Changes in the bar are a personal view until they are saved here.
 */
export type DashboardFilters = {
  /**
   * The date range a dashboard opens on: a relative window, or an absolute range with the label the date picker gave it.
   */
  range?: DashboardRange | undefined;
  /**
   * Values picked per catalog dimension, by field name
   */
  values: { [k: string]: Array<string> };
};

/** @internal */
export const DashboardFilters$inboundSchema: z.ZodMiniType<
  DashboardFilters,
  unknown
> = z.object({
  range: z.optional(DashboardRange$inboundSchema),
  values: z.record(z.string(), z.array(z.string())),
});
/** @internal */
export type DashboardFilters$Outbound = {
  range?: DashboardRange$Outbound | undefined;
  values: { [k: string]: Array<string> };
};

/** @internal */
export const DashboardFilters$outboundSchema: z.ZodMiniType<
  DashboardFilters$Outbound,
  DashboardFilters
> = z.object({
  range: z.optional(DashboardRange$outboundSchema),
  values: z.record(z.string(), z.array(z.string())),
});

export function dashboardFiltersToJSON(
  dashboardFilters: DashboardFilters,
): string {
  return JSON.stringify(
    DashboardFilters$outboundSchema.parse(dashboardFilters),
  );
}
export function dashboardFiltersFromJSON(
  jsonString: string,
): SafeParseResult<DashboardFilters, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DashboardFilters$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DashboardFilters' from JSON`,
  );
}
